import HttpClient from "../../js/repository/HttpClient.js";
import GlobalErrorHandler from "../../js/entities/error/GlobalErrorHandler.js";
import DialogUtils from "../../components/DialogUtils.js";
import HttpErrorHandler from "../../js/entities/error/HttpErrorHandler.js";
import {configInlineMathInMathJax, disableBFCache} from "../../js/util/CommonUtils.js";
import PostPageIoC from "./PostPageIoC.js";
import DropdownList from "../../components/DropdownInput/DropdownList.js";
import DropdownInput from "../../components/DropdownInput/DropdownInput.js";
import IdExtractor from "../../js/util/IdExtractor.js";

window.onload = async () => {
    disableBFCache();
    configInlineMathInMathJax();
    window.customElements.define('dropdown-list', DropdownList);
    window.customElements.define('dropdown-input', DropdownInput);
    DialogUtils.initMutationObserverToPreventScrollWhenDialogIsOpened();
    const globalErrorHandler = new GlobalErrorHandler();
    globalErrorHandler.init();
    globalErrorHandler.addHttpErrorHandler(new HttpErrorHandler());
    const securityContext = await HttpClient.createSecurityContext();
    const ioC = new PostPageIoC(securityContext);
    const postPage = ioC.getPostPageCmp();
    postPage.init(document.querySelector('.post-page'));
    await postPage.show(IdExtractor.extractIdAtUrlEnd());
}